import { useSelector } from 'react-redux'
import jackpotChestVideo from '@media/videos/JackpotChest.mp4'
import { JACKPOT_DETAIL_DISPLAY, JACKPOT_MESSAGES, JACKPOT_TEXTS } from '@constants/jackpotConstants'
import { formatPercentage } from '@core/jackpot/jackpotView'
import { useJackpotNavigation } from '@hooks/jackpot/useJackpotNavigation'
import JackpotOverviewTabs from './JackpotOverviewTabs'

// Screen root for JACKPOT_DETAIL. The full jackpot row is passed via
// navigation params (see useJackpotNavigation) rather than re-fetched — the
// list screens (ActiveJackpotTab/JackpotHistoryTab) already have everything
// this top summary needs.
const JackpotDetail = ({ jackpot, viewType }) => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const { onViewTickets } = useJackpotNavigation()

  if (!jackpot) {
    return (
      <div className="standard-normal-jackpot-detail-empty-container">{JACKPOT_MESSAGES.NO_DETAILS}</div>
    )
  }

  const display = JACKPOT_DETAIL_DISPLAY[viewType] ?? JACKPOT_DETAIL_DISPLAY.ACTIVE
  const filledPercentage = Math.min(100, parseFloat(jackpot.filled || 0)).toFixed(2)
  const winChanceLabel = formatPercentage(jackpot.userContributionPercentage)
  const hasParticipated = Boolean(jackpot.userContributionPercentage)

  return (
    <div className="standard-normal-jackpot-detail-outer-container">
      <div className="standard-normal-jackpot-detail-top-container">
        <div className="standard-normal-jackpot-detail-chest-container">
          <video className="standard-normal-jackpot-detail-chest-video" autoPlay loop muted playsInline>
            <source src={jackpotChestVideo} type="video/mp4" />
          </video>
        </div>

        <div className="standard-normal-jackpot-detail-name">{jackpot.name}</div>

        {display.showEndedDate && (
          <div className="standard-normal-jackpot-detail-row">
            <span>{JACKPOT_TEXTS.ENDED_DATE_PREFIX}&nbsp;</span>
            <span>{jackpot.endedDate}</span>
          </div>
        )}

        {display.showFilledBar && (
          <>
            <div className="standard-normal-jackpot-detail-filled-bar-track">
              <div
                className="standard-normal-jackpot-detail-filled-bar-fill"
                style={{ width: `${filledPercentage}%` }}
              />
            </div>
            <div className="standard-normal-jackpot-detail-filled-percentage">{filledPercentage}%</div>
          </>
        )}

        {display.showMaturityAmount && (
          <div className="standard-normal-jackpot-detail-row">
            <span>{JACKPOT_TEXTS.JACKPOT_VALUE_PREFIX}&nbsp;</span>
            <span>
              {currencyCode} {jackpot.maturityValue}
            </span>
          </div>
        )}

        {display.showWinChance &&
          (hasParticipated ? (
            <div
              className="standard-normal-jackpot-detail-row standard-normal-jackpot-detail-clickable-row"
              onClick={() => onViewTickets(jackpot.id)}
            >
              <span>{JACKPOT_TEXTS.MY_WIN_CHANCE_PREFIX}&nbsp;</span>
              <span>{winChanceLabel}</span>
            </div>
          ) : (
            <div className="standard-normal-jackpot-detail-participation-message">
              {JACKPOT_MESSAGES.BET_TO_JOIN}
            </div>
          ))}

        {display.showTotalReward && (
          <div className="standard-normal-jackpot-detail-row standard-normal-jackpot-detail-total-reward-row">
            <span>{JACKPOT_TEXTS.TOTAL_REWARDS_PREFIX}&nbsp;</span>
            <span>
              {currencyCode} {jackpot.reward ?? 0}
            </span>
          </div>
        )}
      </div>

      <div className="standard-normal-jackpot-detail-bottom-container">
        <JackpotOverviewTabs jackpot={jackpot} viewType={viewType} />
      </div>
    </div>
  )
}

export default JackpotDetail
